export const COMPATIBILITY_ID = 'pdp__compatibility';
export const DESCRIPTION_ID = 'pdp__description';
export const DIAGRAMS_ID = 'pdp__diagrams';
export const SPECIFICIFICATIONS_ID = 'pdp__specifications';
export const RELATED_ID = 'pdp__relatedparts';
export const ALTERNATEPARTS_ID = 'pdp__alternateparts';
export const PACKAGE_BEAN = 'PackageBean';
export const BUNDLE_BEAN = 'BundleBean';
export const PRODUCT_BEAN = 'ProductBean';
export const REMAN_TYPE = 'Reman';
export const INITIAL_REMAN_PARTS = 2;
export const MAX_REMAN_PARTS = 10;
export const GENUINE = 'NPE';
export const VIDEO = 'video';
export const SOFTWARE_PART_TYPE = 'software';
export const SOFTWARE_PART_TYPE_TRAIN = 'Software';
export const XSELL = 'X-SELL';
export const UPSELL = 'UPSELL';
export const NPE = 'NPE';
export const MIN_REPLACED_PARTS = 2;
export const INITIAL_REPLACED_PARTS = 1;
export const PAGE_SIZE = 32;
export const INITIAL_PAGINATION = 1;
export const FBT_LIST_NAME = 'PCC PDP Frequently Bought Together';
export const DEBOUNCE_TIME_SECONDS = 3000;
export const CAT_NAME = 'Cat';
export const PCC_PDP_REPLACEMENTS_PARTS = 'PCC PDP Replacement Parts';
export const PCC_PDP_REMAN_ADD_TO_CART =
  'PCC PDP - Upsell Marketing Associations';
export const PRODUCT_CANONICAL_URL =
  'https://parts.cat.com/{lang}/catcorp/product/{partNumber}';
export const PCC_PDP_KITS_PAGE = 'PCC PDP Kits Page';
export const PRIME_PDP_KITS = 'Prime PDP Kits';
export const RELATED_PARTS_GA_LIST_NAME = 'PCC PDP Page Related Parts';
export const ALTERNATE_PARTS_LIST = 'PCC PDP Page Alternate Parts';
export const PRODUCT_STATUS_DISCONTINUED = 'Discontinued';
export const MAX_HEIGHT_FOR_COMPATIBLE_MODELS = 60;
export const COOKIE_BROWSING_HISTORY = 'browsingHistory';
export const SECONDS_PER_DAY = 86400;
export const MILLISECONDS_IN_A_SECOND = 1000;
export const MAX_DAYS = 14;
export const BY_COMMA = '%2C';
export const MAX_PRODUCTS = 200;
export const PATH = '/';
export const FUSION_QUERY_ID = 'FUSION_QUERY_ID';
export const PDP_ESPOT_5_NAME = 'PCC_PDP_Layout_V2_eSpot-5';

export const PDP_PAGE_DIAGRAM_GA_ATTRIBUTES = {
  'data-track-event': 'e_productNav',
  'data-track-attr-nltext': 'Diagram view',
  'data-track-attr-context': 'Parts Diagram page header section'
};

export const PDP_PAGE_LIST_GA_ATTRIBUTES = {
  'data-track-event': 'e_productNav',
  'data-track-attr-nltext': 'List view',
  'data-track-attr-context': 'Parts Diagram page header section'
};
